import { useMemo } from 'react'

import { useApiRequest } from '@tabeeb/shared/utils/hooks'

import { PrepareSplatModelResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { prepareCreateSplatModel } from '../actions'

interface UsePrepareCreateSplatProps {
  pageIds: number[]
  onError: (error: unknown) => void
  enabled: boolean
}

interface UsePrepareCreateSplatState {
  loading: boolean
  loaded: boolean
  splatModel: PrepareSplatModelResponse | null
}

export default ({ pageIds, onError, enabled }: UsePrepareCreateSplatProps): UsePrepareCreateSplatState => {
  const payload = useMemo(() => ({ pageIds }), [pageIds])

  const {
    response: splatModel,
    loaded,
    loading,
  } = useApiRequest({
    defaultResponse: null,
    request: prepareCreateSplatModel.request,
    payload,
    enabled,
    onError,
  })

  return { loading, loaded, splatModel }
}
